/**
 * 深度优先遍历树，迭代器返回true以便停止遍历
 * @param {Array} tree 树形结构数组
 * @param {Function} iterator 迭代器函数，参数为当前节点，返回true则停止遍历
 * @param {String} childrenKey 子节点的键名，默认为'children'
 */
export function iterateTree(tree, iterator, childrenKey = 'children') {
  for (let node of tree) {
    if (iterator(node)) return true
    if (iterateTree(node[childrenKey], iterator, childrenKey)) return true
  }
  return false
}

/**
 * 列表转树
 * @param {Array} list 列表数组
 * @param {String} idKey 节点唯一标识键名，默认为'id'
 * @param {String} parentIdKey 父节点标识键名，默认为'parentId'
 * @param {String} childrenKey 子节点键名，默认为'children'
 */
export function list2tree(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
  const tree = list.filter((node) => node[parentIdKey] === null)
  const setChildren = (node) => {
    node[childrenKey] = list.filter((child) => child[parentIdKey] === node[idKey])
    node[childrenKey].forEach(setChildren)
  }
  tree.forEach(setChildren)
  return tree
}

/**
 *获取树节点对应的的Map,key为id,value为节点数组,数组顺序为从根节点到自身,不修改原树结构
 * @param {Array} tree 树形结构数组
 * @param {String} childrenKey 子节点的键名，默认为'children'
 * @param {String} idKey 节点唯一标识键名，默认为'id'
 */
export function tree2map(tree, childrenKey = 'children', idKey = 'id') {
  const map = {}
  iterateTree(
    tree,
    (node) => {
      const nodeId = node[idKey]
      map[nodeId] = map[nodeId] || [node]
      node[childrenKey].forEach((child) => {
        map[child[idKey]] = [...(map[nodeId] || []), child]
      })
    },
    childrenKey
  )
  return map
}

/**
 * 获取后代节点的id数组(包含自身)
 * @param {Array} tree 树形结构数组
 * @param {String} id 节点id
 * @param {String} childrenKey 子节点的键名，默认为'children'
 * @param {String} idKey 节点唯一标识键名，默认为'id'
 */
export function getDescendantIds(tree, id, childrenKey = 'children', idKey = 'id') {
  let targetNode = null
  iterateTree(
    tree,
    (node) => {
      if (node[idKey] === id) {
        targetNode = node
        return true
      }
    },
    childrenKey
  )
  if (!targetNode) return []
  const ids = [id]
  iterateTree(targetNode[childrenKey], (node) => {
    ids.push(node[idKey])
  })
  return ids
}

export default {
  iterateTree,
  list2tree,
  tree2map,
  getDescendantIds
}
